import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { DashboardLayout } from '../components/UI/Layout/DashboardLayout';
import LocationDetailComponent from 'components/Locations/Detail/LocationDetailComponent';

export const LocationDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        document.title = 'Location Detail - Organizations';
    }, []);

    return (
        <DashboardLayout>
            {/* Remounts per location so filters, modals and fetched data don't carry over to another location */}
            <LocationDetailComponent key={id} />
        </DashboardLayout>
    );
};

export default LocationDetail;
